import { store as app } from '../../domains'

export default { ...app }
